import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth';
import { LoadingText } from '../components/Style';
import { trackEvent } from '../analytics';
import api from '../api';

function GoogleCallback() {
  var { setAuthTokens } = useAuth();
  var navigate = useNavigate();
  var [done, setDone] = useState(false);
  var [error, setError] = useState('');

  useEffect(function () {
    var params = new URLSearchParams(window.location.search);
    var credential = params.get('credential');

    if (!credential) {
      setError('No credential received from Google.');
      return;
    }

    api
      .post('/api/users/social-login', {
        provider: 'google',
        idToken: credential,
      })
      .then(function (result) {
        if (result.status === 200) {
          if (result.data.needsUsername) {
            navigate('/choose-username', {
              state: {
                email: result.data.email,
                suggestedName: result.data.suggestedName,
                provider: result.data.provider,
                idToken: credential,
                referrerID: localStorage.getItem('signup_referrer') || '',
              },
            });
            return;
          }
          var auth = {
            user: result.data.user,
            token: result.data.token,
          };
          setAuthTokens(auth);
          localStorage.setItem('hr_has_logged_in', 'true');
          trackEvent('login_completed', { method: 'google' });
          setDone(true);
        } else {
          setError('Login failed. Please try again.');
        }
      })
      .catch(function (e) {
        var message = e.response?.data?.reason || 'Login failed. Please try again.';
        setError(message);
      });
  }, []);

  if (done) {
    return <Navigate to="/" replace />;
  }

  if (error) {
    return <LoadingText style={{ color: 'tomato' }}>{error}</LoadingText>;
  }

  return <LoadingText>Signing in...</LoadingText>;
}

export default GoogleCallback;
